// extracted by mini-css-extract-plugin
export default {"welcome_card":"welcome_card____D0om","img":"img___w9pmU","title":"title___a3nFI","text":"text___G9Exw","btn":"btn___Ax0T5","close":"close___nR04m","text_sm":"text_sm___lt1ww"};